/** @format */

import React, { memo } from 'react'
import { useDispatch } from 'react-redux'

import { authSocialFetch } from 'services/auth/operation'
import { Icon } from 'components'

import styles from './SocialMedia.module.css'

export const SocialMedia = memo(() => {
  const dispatch = useDispatch()

  const handleGoogle = () => dispatch(authSocialFetch('Google'))
  const handleFacebook = () => dispatch(authSocialFetch('Facebook'))
  const handleTwitter = () => dispatch(authSocialFetch('Twitter'))
  const handleGithub = () => dispatch(authSocialFetch('Github'))
  const handleMicrosoft = () => dispatch(authSocialFetch('O'))
  const handleYahoo = () => dispatch(authSocialFetch('O'))

  return (
    <div className={styles.wrapper}>
      <div className={styles.or}>
        <div className={styles.or__line} />
        <p className={styles.or__text}>OR</p>
        <div className={styles.or__line} />
      </div>
      <div className={styles.socialMedia}>
        <Icon name="google" style={styles.icon} onClick={handleGoogle} />
        <Icon name="facebook" style={styles.icon} onClick={handleFacebook} />
        <Icon name="twitter" style={styles.icon} onClick={handleTwitter} />
        <Icon name="github" style={styles.icon} onClick={handleGithub} />
        <Icon name="microsoft" style={styles.icon} onClick={handleMicrosoft} />
        <Icon name="yahoo" style={styles.icon} onClick={handleYahoo} />
      </div>
    </div>
  )
})
